import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { processDesc, addCost, CARD_TYPE, CARD_CATEGORY } from '../shared/parse';
import { BANNER_COLOR } from '../shared/types';

import style from './card.scss';
import { cardExpansion, friendlyURL } from '../shared/utils';

export class CardComponent extends LitElement {

    static get properties() {
        return {
            data: Object,
            id: Number,
            link: String,
            ver: String,
            talent: String
        }
    }

    constructor() {
        super();
        this.id = null;
        this.loadedID = -1;
        this.data = null;
        this.link = '';
        this.ver = '';
        this.talent = '';
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        this.fetchData();
    }

    async fetchData() {
        if (!this.id || this.id === -1) {
            return;
        }
        let cardjson = await fetch(`./api/card/${this.id}${this.ver ? `?ver=${this.ver}&talent=${this.talent}` : `?talent=${this.talent}`}`);
        let card = await cardjson.json();
        this.data = card;
    }

    render() {
        if (this.id !== this.loadedID && this.id) {
            this.loadedID = this.id;
            this.fetchData();
            return html`<div class="bubble" style="background:#000;color:#fff;font-size:14px;">Loading...</div>`;
        }
        let card = this.data;
        if (!this.data || !this.id)
            return html``;
        return html`
            <div class="card">
                <h3 class="${card.category === 10 ? 'talent' : 'card'}-rarity-${card.rarity}">${card.url ? html`<a href=${card.url} target="_blank">${card.nameLocalized||card.name}</a>`:card.nameLocalized||card.name}</h3>                
                <small>                    
                    ${CARD_TYPE[card.type]} 
                    ${card.name.indexOf('Offer of') === 0 ? 'Infernal Offering' : CARD_CATEGORY[card.category]}
                    ${card.color ? ` [${BANNER_COLOR[card.color]}]` : ''}
                </small>                
                <div class="artwork ${card.category === 10 ? 'talent' : 'card'}-rarity-${card.rarity}" 
                    style="background-image:url(./images/icons/${(card.artwork || 'dt_portrait_bolgar').replace(/ /g, '%20')}.webp);"></div>
                <div class="cost-div">
                    ${addCost(card, 'dex')}${addCost(card, 'dexint')}${addCost(card, 'dexstr')}${addCost(card, 'int')}${addCost(card, 'intstr')}${addCost(card, 'str')}${addCost(card, 'holy')}${addCost(card, 'blood')}${addCost(card, 'neutral')}${card.tier && card.name.indexOf('Offer of') !== 0 ? 'Tier ' + card.tier : ''}
                </div>
                <span class="card-desc" style="${card.votes?'min-height: 70px;':''}">
                    ${unsafeHTML(processDesc(card.description))}                   
                    <span class="flavor">${card.flavortext || ''}</span>
                </span>
                ${unsafeHTML(cardExpansion(card))}    
                ${card.designedBy && card.designedBy !== 'Wanderlost' ? html`<br><div style="transform:scale(0.7);transform-origin: left;">Designed by <discorduser-component user=${card.designedBy}></discorduser-component></div>`:''}
                ${this.link ? html`<br><a style="color: #fff;text-decoration: underline;" href="./${this.talent === 'true' || card.category === 10 ? 'talent' : 'card'}/${friendlyURL(card.name)}">Open Link</a>` : ''}
            </div>
        `;
    }
}

customElements.define('card-component', CardComponent);